export default {
  title: 'Coș',
};
